import moment from "moment";
import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants";

export const conditionStatusOptions = [
    {value: "active", name: "Active"},
    {value: "inactive", name: "Inactive"},
    {value: "remission", name: "Remission"},
    {value: "resolved", name: "Resolved"},
    {value: "recurrence", name: "Recurrence"},
    {value: "relapse", name: "Relapse"}
]

export const familyHistoryOptions = [
    {value: "MTH", name: "Mother"},
    {value: "FTH", name: "Father"},
    {value: "BRO", name: "Brother"},
    {value: "SIS", name: "Sister"},
    {value: "GRMTH", name: "Grandmother"},
    {value: "GRFTH", name: "Grandfather"},
    {value: "AUNT", name: "Aunt"},
    {value: "UNCLE", name: "Uncle"},
    {value: "SON", name: "Son"},
    {value: "DAU", name: "Daughter"},
    {value: "EXT", name: "Other"}
]

export const observationNameOptions = [
    {value: "Pregnancies", name: "Pregnancies"},
    {value: "Personal/Social", name: "Personal/Social"},
]

export const FormikObjectCondition = {
    initialValues: {
        conditionName: "",
        diagnosisDate: moment().format("YYYY-MM-DD"),
        status:"",
        note:""
    },
    validationSchema: Yup.object({
        conditionName: conditionalValidation(
            Yup.string().max(50, "Maximum length is 50 characters.").matches(/^$|^\S+.*/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Name",
                mandatory: true
            }),
        // status: Yup.string().required("Required status field"),
        diagnosisDate: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Date",
                mandatory: true
            }),
        note: conditionalValidation(
            Yup.string().max(250, "Maximum length is 250 characters.").matches(/^$|^\S+.*/, 'Only blankspaces is not valid.'),
            {
                validation,
                label:"Note"
            })
    }),
}

export const FormikObjectSurgeryScreening = {
    initialValues: {
        procedureName: "",
        performedDateTime: moment().format("YYYY-MM-DD"),
        note:""
    },
    validationSchema: Yup.object({
        procedureName: conditionalValidation(
            Yup.string().max(50, "Maximum length is 50 characters.").matches(/^$|^\S+.*/, 'Only blankspaces is not valid.'),
            {
                mandatory: true,
                validation,
                label: "Procedure Name"
            }),
        performedDateTime: conditionalValidation(
            Yup.string(),
            {
                validation,
                mandatory: true,
                label: "Procedure Date"
            }),
        note: conditionalValidation(
            Yup.string().max(250, "Maximum length is 250 characters.").matches(/^$|^\S+.*/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Note"
            })
    }),
}

export const FormikObjectFamilyHistory = {
  initialValues: {
    conditionName: "",
    // date: moment().format("YYYY-MM-DD"),
    relationship: "",
    relation: "",
    relationshipCode: "",
    ageValue: "",
    note: "",
  },
  validationSchema: Yup.object({
    conditionName: conditionalValidation(
        Yup.string()
            .max(50, "Maximum length is 50 characters.")
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
        {
            validation,
            label: "Family History",
            mandatory: true
        }),
    // relation: Yup.string().required("Required relationship field"),
    relationship: conditionalValidation(
        Yup.string().when("relation", (relation, schema) =>
        relation === "EXT"
            ? Yup.string()
                .max(25, "Maximum length is 25 characters.")
                .required("Required Other field")
            : Yup.string().notRequired()),
            {
                validation,
                label: "Other"
            }),
    ageValue: conditionalValidation(
        Yup.string()
        .test("is-three-digits", "Age must be a 1-3 digit number.", (value) =>
        /^\d{0,3}$/.test(value)
        ).test("max-age", "Maximum allowed age is 120.", (value) => {
            const numericValue = parseInt(value, 10);
            return numericValue <= 120;
        }), 
        {
            validation,
            label: "Age of Onset",
            mandatory: true
        }),
    note: conditionalValidation(
        Yup.string()
            .max(250, "Maximum length is 250 characters.")
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
        {
            validation,
            label: "Note"
        })
  }),
};

export const FormikObjectObservaton = {
    initialValues: {
        observationName: "",
        note:""
    },
    validationSchema: Yup.object({
        observationName: conditionalValidation(
            Yup.string().max(50, "Maximum length is 50 characters.").matches(/^$|^\S+.*/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Observation",
                mandatory: true
            }),
        note: conditionalValidation(
            Yup.string().max(250, "Maximum length is 250 characters.").matches(/^$|^\S+.*/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Note"
            })
    }),
}

export const FormikObjectNote = {
    initialValues: {
        note:""
    },
    validationSchema: Yup.object({
        note: conditionalValidation(
            Yup.string().max(250, "Maximum length is 250 characters.").matches(/^$|^\S+.*/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Note",
                mandatory: true
            })
    }),
}